var videoPlayer = videojs('my-video', {
    // You can remove autoplay: 'muted' and loop: true here 
    // since they are now in the HTML, but keeping them is fine.
    controls: false,
    preload: 'auto',
    playsinline: true // This is correctly set
    
});

// Alternatively, you can use a promise-based approach to handle autoplay failure
videoPlayer.ready(function() {
    var promise = videoPlayer.play();
    if (promise !== undefined) {
        promise.then(function() {
            // Autoplay started
        }).catch(function(error) {
            // Autoplay failed, likely because of sound. Mute and try again.
            videoPlayer.muted(true);
            videoPlayer.play();
        });
    }
});